import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PlayerSelectorComponent } from 'src/app/features/handball/player/view/player-selector/player-selector.component';
import { PlayerHealthComponent } from "../../features/handball/player/view/player-health/player-health.component";
import { Player, PlayerListItem } from 'src/app/features/handball/player/model/player';
import { PlayerService } from 'src/app/features/handball/player/controller/player.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrl: './health.component.scss',
  standalone: true,
  imports: [CommonModule, PlayerSelectorComponent, PlayerHealthComponent],
})
export class HealthComponent implements OnInit {

  player: Player;

  constructor(
    private playerService: PlayerService
  ) { }

  ngOnInit() {
  }

  onPlayerSelected(playerListItem: PlayerListItem) {
    this.player = this.playerService.getPlayers().find((player) => player.id === playerListItem.id);
  }

}
